import styled from 'styled-components';
import { screen } from 'theme';

const Root = styled.div`
  background: #d7edf1;
  padding: 4rem 1rem;

  @media (min-width: ${screen('xl')}) {
    padding: 4rem 0;
  }

  h2 {
    margin-bottom: 3rem;
  }

  h3 {
    margin: 0;
  }

  .blur {
    filter: blur(6px);
  }

  .badgeList {
    flex-direction: row;
  }

  .slick-dots {
    position: relative;
    top: -2rem !important;
    display: none !important;

    @media (min-width: ${screen('xl')}) {
      display: block !important;
    }
  }

  .slick-arrow {
    display: block !important;

    width: 30px;
    height: 30px;
    top: 30%;

    &.slick-prev {
      left: -15px;
    }

    &.slick-next {
      right: -15px;
    }

    &:before {
      font-size: 30px;
      color: #35b7b2;
    }

    @media (min-width: ${screen('xl')}) {
      display: none !important;
    }
  }

  li.slick-active > button {
    background: #dcb4e8 !important;
    border-color: #dcb4e8 !important;
  }

  .card {
    position: relative;
    margin: 0;

    @media (min-width: ${screen('sm')}) {
      margin: 0 1rem;
    }

    strong {
      min-width: 130px;
    }

    .like {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      padding: 0.35rem;
      gap: 0;

      > span > span {
        display: none;
      }

      @media (min-width: ${screen('md')}) {
        gap: 0.5rem;
        padding: 0.5rem;

        > span > span {
          display: inline-block;
        }
      }
    }
  }
`;

export const Location = styled.div`
  color: ${({ theme }) => theme.palette.text.subtle};
  font-size: 0.875rem;
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const YourOfferSalaryCtaStyles = {
  Root,
  Location,
  AvatarContainer
};
